import CollectionEditTableMain from "./components/CollectionEditTable/CollectionEditTableMain"
import CollectionEditTableOptions from "./components/CollectionEditTableOptions/CollectionEditTableOptions"


const CollectionEditTable = () => {
  return (
    <div style={{ width: '100%' }}>
      <CollectionEditTableOptions />
      <CollectionEditTableMain />
    </div>
  )
}

export default CollectionEditTable
